import { post, get, PostWithData } from "../https";
import { getCountry, getUserToken } from "../../../common/userfuctions";
import axios from "axios";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

export const CheckEmail = (
  employer,
  email = "",
  type = "Email",
  AuthDetails = {},
  UserInfo = {},
  Source = "Web",
  ShareLogin = 0,
  ShareLoginEmail = ""
) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "CheckEmail",
    member: 1,
    p: JSON.stringify({
      EmailAddress: email,
      Type: type,
      AuthDetails: AuthDetails,
      UserInfo: UserInfo,
      Source: Source,
      ShareLogin,
      ShareLoginEmail,
      IPCountry: country,
    }),
  };
  if (employer) {
    let paramsObj = JSON.parse(params.p);
    paramsObj.Employer = 1;
    params.p = JSON.stringify(paramsObj);
  }
  // return params;
  return post(SERVER_URL, null, params);
};

export const VerifyEmail = (employer, email, Code) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "VerifyEmail",
    member: 1,
    p: JSON.stringify({
      EmailAddress: email,
      Code: Code,
      IPCountry: country,
    }),
  };

  if (employer) {
    let paramsObj = JSON.parse(params.p);
    paramsObj.Employer = 1;
    params.p = JSON.stringify(paramsObj);
  }

  return post(SERVER_URL, null, params);
};

export const EmployerSignUp1 = (companyName, email) => {
  const country = getCountry();

  let params = {
    r: "Employers",
    rt: "SignUp_Step1",
    employer: 1,
    p: JSON.stringify({
      CompanyName: companyName,
      EmailAddress: email,
      IPCountry: country,
    }),
  };

  return get(SERVER_URL, params);
};

export const EmployerSignUp2 = (
  companyName,
  emailAddress,
  firstName,
  lastName,
  designation,
  Country,
  city,
  phoneNumber
) => {
  const country = getCountry();

  let params = {
    r: "Employers",
    rt: "SignUp_Step2",
    employer: 1,
    p: JSON.stringify({
      CompanyName: companyName,
      EmailAddress: emailAddress,
      FirstName: firstName,
      LastName: lastName,
      Designation: designation,
      Country: Country,
      City: city,
      PhoneNumber: phoneNumber,
      IPCountry: country,
    }),
  };

  return get(SERVER_URL, params);
};

export const Login = (email, password) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "Login",
    member: 1,
    p: JSON.stringify({
      EmailAddress: email,
      Password: password,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const UpdateMemberInfo = (data) => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "UpdateMemberInfo",
      AccessToken: UserToken,
      FirstName: data?.firstName,
      LastName: data?.lastName,
      Data: data,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetContInfoForm = () => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "ContactInfoForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const AccountSettingsSave = (data) => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "AccountSettingsSave",
      AccessToken: UserToken,
      Data: data.values,
      Source: data.Source,
      InterestTags: data.interestTags,
      IPCountry: country,
    }),
  };

  if (data.employer) {
    let paramsObj = JSON.parse(params.p);
    paramsObj.Employer = 1;
    params.p = JSON.stringify(paramsObj);
  }

  return post(SERVER_URL, null, params);
};

export const ContactInfoUpdate = (data) => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "ContactInfoFormSave",
      AccessToken: UserToken,
      Data: data,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
export const GetAuthURL = (AuthType, ShareLogin = 0) => {
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "GetAuthURL",
    member: 1,
    p: JSON.stringify({
      AuthType: AuthType,
      ShareLogin: ShareLogin,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const SaveUserLocation = async (loc) => {
  const res = await get("https://geolocation-db.com/json/");
  return res;
  // let params = {
  //   r: "Web",
  //   rt: "SaveUserLocation",
  //   p: JSON.stringify({
  //     location: {
  //       latitude: loc.coords.latitude,
  //       longitude: loc.coords.longitude,
  //     },
  //   }),
  // };

  // return post(SERVER_URL, null, params);
};

export const UnsubscribeEmail = async ({ email }) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "Unsubscribe",
    p: JSON.stringify({
      EmailAddress: email,
      IPCountry: country,
    }),
    u: email,
  };
  return post(SERVER_URL, null, params);
};

export const ChangePassword = async ({
  AccessToken = "",
  CurrentPassword = "",
  NewPassword = "",
  ConfirmNewPassword = "",
}) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "ChangePassword",
      AccessToken,
      CurrentPassword,
      NewPassword,
      ConfirmNewPassword,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const VerifyEmailForResetPassword = async ( EmailAddress = "" ) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "ForgotPassword",
    member: 1,
    p: JSON.stringify({
      EmailAddress,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const removeProfilePic = () => {
  const UserToken = getUserToken();
  const country = getCountry();

  const config = {
    params: {
      r: "Members",
      rt: "RemoveProfilePicture",
      p: JSON.stringify({
        AccessToken: UserToken,
        IPCountry: country
      }),
    },
  };
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios
        .post(SERVER_URL, null, config)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        }, 1000);
    });
  });
};
export const uploadFile = (formData) => {
  const country = getCountry();
  const config = {
    params: {
      r: "Upload",
      rt: "UploadFile",
      p: JSON.stringify({
        IPCountry : country
      }),
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios
        .post(SERVER_URL, formData, config)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        }, 1000);
    });
  });
};

export const uploadProfile = async (fileName) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "UploadPhoto",
      AccessToken: UserToken,
      Photo: fileName,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const deleteProfile = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "DeletePhoto",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const uploadResume = async (fileName) => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "UploadResume",
      AccessToken: UserToken,
      Resume: { FileName: fileName },
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const uploadProfileDocuments = async (files) => {
  const country = getCountry();
  const UserToken = getUserToken();
  return post(SERVER_URL, null, {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "UploadProfileDocuments",
      AccessToken: UserToken,
      Files: files,
      IPCountry: country,
    }),
  });
};

export const deleteProfileDocument = async (storageKey) => {
  const country = getCountry();
  const UserToken = getUserToken();
  return post(SERVER_URL, null, {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "DeleteProfileDocument",
      AccessToken: UserToken,
      StorageKey: storageKey,
      IPCountry: country,
    }),
  });
};

export const getUserResume = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "GetResume",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetMyProfileData = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "GetProfile",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const SaveLanguages = async (data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "SaveLanguage",
      AccessToken: UserToken,
      Data: data,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const OnSearchSkill = async (data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "SearchSkills",
      AccessToken: UserToken,
      q: data,
      IPCountry: country,
    }),
  };

  return PostWithData(SERVER_URL, params, null);
};

export const SaveSkills = async (data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "SaveSkill",
      AccessToken: UserToken,
      Data: data,
      IPCountry: country,
    }),
  };

  return PostWithData(SERVER_URL, params, null);

};

export const ExperienceOperation = async ({ index, action, data }) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "WorkExperienceOperation",
      Action: action,
      Index: index,
      Data: data,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const CertificateOperation = async ({ index, action, data }) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "CertificationsOperation",
      Action: action,
      Index: index,
      Data: data,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const EducationOperation = async ({ index, action, data }) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "EducationOperation",
      Action: action,
      Index: index,
      Data: data,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const SaveBasicInfo = async (data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "SaveBasicInfo",
      Data: data,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getAccountSettingsForm = async ({ Source }) => {
  const country = getCountry();

  const UserToken = getUserToken();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "AccountSettingsForm",
      AccessToken: UserToken,
      Source: Source,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const deleteResume = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "DeleteResume",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getMemberData = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Data",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetExperienceForm = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "WorkExperienceForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
export const GetEducationForm = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "EducationForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetCertificateForm = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "CertificationsForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetBasicInfoForm = async () => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "BasicInfoForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const BasicInfoSave = async (data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "BasicInfoForm",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const ChangeInfo = async (Data) => {
  const country = getCountry();

  const UserToken = getUserToken();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "Profile",
      rt3: "ChangeProfileInfo",
      Data: Data,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const ResetPassword = async ({
  EmailAddress = "",
  PasswordResetCode = "",
  NewPassword = "",
  ConfirmNewPassword = "",
}) => {
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "ResetPassword",
    member: 1,
    p: JSON.stringify({
      EmailAddress,
      PasswordResetCode,
      NewPassword,
      ConfirmNewPassword,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
